module.exports = __webpack_public_path__ + "img/icon-menubar-my-active.5a51c0c4.png";